import { EDirection } from 'src/styles/theme/utils/enums';
import { addFramesStyles, addMarginStyles } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { INGGradientSeparator } from './NGGradientSeparator.type';

export const StyledNGGradientSeparator = styled.span<INGGradientSeparator>`
	position: relative;
	z-index: 10;

	display: block;

	${(p) =>
		p.direction === EDirection.vertical
			? css`
					width: 1px;
					height: 100%;
			  `
			: css`
					height: 1px;
					width: 100%;
					flex-shrink: 0;
			  `}

	${(p) => `
		${addMarginStyles(p)}
		${addFramesStyles(p)}
	`}

	background: ${(p) => `
		radial-gradient(${p.theme.colors.white + '30'}, ${p.theme.colors.white + '00'});
	`};
`;
